/* eslint-disable import/order */
import initRum from './rum';
import { directAccessGuardLoader } from 'routes/DirectAccessGuard';

initRum();

/* eslint-disable import/first */
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import SelectTeamPage from 'pages/SelectTeamPage.tsx';
import ActivityPage from 'pages/ActivityPage.tsx';
import PageLayout from 'components/layouts/PageLayout.tsx';
import Home from 'components/Home/Home.tsx';
import { AuthProvider } from 'contexts/AuthContext';
import './global_styles/main.css';
import './index.css';
import ErrorPage from 'pages/ErrorPage';
import campaignRoutes from 'routes/CampaignRoutes';
import adminRoutes from 'routes/AdminRoutes';
import featureFlags from 'services/featureFlags.ts';
import NotFoundPage from 'pages/NotFoundPage';
import ErrorBoundary from 'components/ErrorBoundary';
import Campaigns from 'pages/Campaigns';

const router = createBrowserRouter([
  {
    loader: directAccessGuardLoader,
    // Campaign creation carries the selected template in ?template=... before navigating to confirmation.
    // Run this guard for direct visits only, not during campaign or iteration journeys to guarded pages.
    // See https://reactrouter.com/6.30.1/route/should-revalidate
    shouldRevalidate: () => false,
    path: '/',
    element: (
      <ErrorBoundary showStackTrace={featureFlags.devtoolsEnabled}>
        <Outlet />
      </ErrorBoundary>
    ),
    children: [
      {
        path: '',
        element: <PageLayout />,
        children: [{ path: '', element: <Home /> }],
      },
      {
        path: 'home',
        element: <PageLayout />,
        children: [{ path: '', element: <Home /> }],
      },
      { path: 'error', element: <ErrorPage /> },
      {
        path: 'campaigns',
        element: <PageLayout />,
        children: [{ path: '', element: <Campaigns /> }],
      },
      {
        path: 'select-team',
        element: <PageLayout />,
        children: [{ path: '', element: <SelectTeamPage /> }],
      },
      {
        path: 'activity',
        element: <PageLayout />,
        children: [{ path: '', element: <ActivityPage /> }],
      },
      ...campaignRoutes,
    ],
  },
  ...adminRoutes,
  { path: '*', element: <NotFoundPage /> },
]);

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        {featureFlags.devtoolsEnabled && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
